import { connect } from "react-redux";
import get from "lodash/get";

import {
  createCustomReport as onCreateCustomReport,
  selectedCustomReport as onSelectedCustomReport,
  unselectedCustomReport as onUnselectedCustomReport,
  deleteCustomReport as onDeleteCustomReport,
  updateCustomReportTitle as onUpdateCustomReportTitle,
  deleteCustomReportDahsboard as onDeleteCustomReportDahsboard,
  shiftCustomReportDahsboard as onShiftCustomReportDahsboard,
  updateCustomReportDashboard as onUpdateCustomReportDashboard,
  addCustomReportDashboard as onAddCustomReportDashboard,
  deleteCustomReportField as onDeleteCustomReportField,
  addCustomReportField as onAddCustomReportField,
  updateCustomReportField as onUpdateCustomReportField,
  shiftCustomReportField as onShiftCustomReportField,
  downloadExampleCustomReport as onDownloadExampleCustomReport,
  updateCustomReportAxis as onUpdateCustomReportAxis,
} from "../../actions/customReportActions";

const mapStateToProps = (state) => ({
  createCustomReportDataState: state.customReport.createCustomReportDataState,
  deleteCustomReportDataState: state.customReport.deleteCustomReportDataState,
  deleteCustomReportDahsboardDataState: state.customReport.deleteCustomReportDahsboardDataState,
  shiftCustomReportDahsboardDataState: state.customReport.shiftCustomReportDahsboardDataState,
  addCustomReportDahsboardDataState: state.customReport.addCustomReportDahsboardDataState,
  updateCustomReportDahsboardDataState: state.customReport.updateCustomReportDahsboardDataState,
  updateCustomReportTitleDataState: state.customReport.updateCustomReportTitleDataState,
  deleteCustomReportFieldDataState: state.customReport.deleteCustomReportFieldDataState,
  addCustomReportFieldDataState: state.customReport.addCustomReportFieldDataState,
  updateCustomReportFieldDataState: state.customReport.updateCustomReportFieldDataState,
  updateCustomReportAxisDataState: state.customReport.updateCustomReportAxisDataState,
  shiftCustomReportFieldDataState: state.customReport.shiftCustomReportFieldDataState,
  downloadExampleCustomReportDataState: state.customReport.downloadExampleCustomReportDataState,
  selectedCustomReportId: get(state, ["customReport", "selectedCustomReportId"], null),
});

const mapDispatchToProps = {
  onCreateCustomReport,
  onSelectedCustomReport,
  onUnselectedCustomReport,
  onDeleteCustomReport,
  onUpdateCustomReportTitle,
  onDeleteCustomReportDahsboard,
  onShiftCustomReportDahsboard,
  onUpdateCustomReportDashboard,
  onAddCustomReportDashboard,
  onDeleteCustomReportField,
  onAddCustomReportField,
  onUpdateCustomReportField,
  onShiftCustomReportField,
  onDownloadExampleCustomReport,
  onUpdateCustomReportAxis,
};

const withCustomReport = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withCustomReport };
